import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import founderImage from "../../../assets/images/landing/features/founder.png"; 
const FoundersStake = () => {
    return (
        <React.Fragment>
            <section className="section pb-0 hero-section" id="hero" style={{backgroundColor:"rgb(52, 81, 159)"}}>
                {/* <div className="bg-overlay bg-overlay-pattern"></div> */}
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <div className="container  " >
                                <div className="row align-items-center">
                                    <Col lg={6} md={12} className="text-center">
                                        <img
                                            src={founderImage}
                                            alt="Founder"
                                            className="img-fluid rounded"
                                            style={{ maxWidth: "300px" }}
                                        />
                                    </Col>

                                    <Col lg={6} md={12}>
                                        <h2 className="fw-bold text-white">Founder’s Take</h2>
                                        <p className="text-white">
                                            “Companies are under tremendous pressure to streamline their
                                            indirect purchases & office supplies. They are facing recurring
                                            problems with unorganized purchases due to multiple vendors for
                                            various admin services.
                                        </p>
                                        <p className="text-white">
                                            We are solving this age-old problem with Offiso as a single supplier
                                            for multiple brands & building simplified distribution in admin
                                            services for all office supplies across pan India.”
                                        </p>
                                        <p className="fw-semibold text-white">-By Shivanand Bukkigar</p>
                                    </Col>

                                </div>
                            </div>
                            <div className='mt-4 mt-sm-5 pt-sm-5 mb-sm-n5 demo-carousel' >
                                
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default FoundersStake;